import { Component } from '@angular/core';
// import Highcharts from 'highcharts';
// import * as HPMap from '@highcharts/map-collection/countries/in/in-hp-all.geo.json'; // Import HP map GeoJSON
// import HPMap from '@highcharts/map-collection/countries/in/in-hp-all.geo.json';
import * as Highcharts from 'highcharts/highmaps';
import HPMap from '../../hp-geo.json';
import { AdminService } from '../../service/admin.service';
import { CommonModule } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';
@Component({
  selector: 'app-societies-details',
  standalone:true,
  imports:[CommonModule,HighchartsChartModule],
  templateUrl: './societies-details.component.html',
  styleUrls: ['./societies-details.component.scss'],

})
export class SocietiesDetailsComponent {
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = 'mapChart';
  chartOptions: Highcharts.Options = {};

  // Sample data from your input
mapData = [
  { 'hc-key': 'in-hp-ma', value: 921, name: 'MANDI' },
  { 'hc-key': 'in-hp-kg', value: 1167, name: 'KANGRA' },
  { 'hc-key': 'in-hp-sm', value: 753, name: 'SHIMLA' },
  { 'hc-key': 'in-hp-ku', value: 744, name: 'KULLU' },
  { 'hc-key': 'in-hp-sr', value: 314, name: 'SIRMAUR' },
  { 'hc-key': 'in-hp-sl', value: 455, name: 'SOLAN' },
  { 'hc-key': 'in-hp-un', value: 388, name: 'UNA' },
  { 'hc-key': 'in-hp-ch', value: 284, name: 'CHAMBA' },
  { 'hc-key': 'in-hp-ha', value: 357,  name: 'HAMIRPUR' },
  { 'hc-key': 'in-hp-bl', value: 231,  name: 'BILASPUR' },
  { 'hc-key': 'in-hp-ls', value: 128,  name: 'LAHUL & SPITI' },
  { 'hc-key': 'in-hp-kn', value: 97,  name: 'KINNAUR' }
];
  show = false
  constructor(private adminService: AdminService) {

  }
  ngOnInit(): void {

    // this.chartOptions =  {
    //     chart: { map: HPMap },
    //     title: { text: 'Societies by District – Himachal Pradesh' },
    //     colorAxis: { min: 0 },
    //     series: [{
    //       type: 'map',
    //       name: 'Society Count',
    //       joinBy: ['district', 'name'], // Ensure these properties match the GeoJSON
    //       data:this.mapData
    //     }]
    //   };
    this.GetDistrictSocietyDetail()
  }
  GetDistrictSocietyDetail() {
let data 
    =[
    {
        "IDistrictId": 10,
        "name": "Kangra",
        "value": 1167
    },
    {
        "IDistrictId": 4,
        "name": "Mandi",
        "value": 921
    },
    {
        "IDistrictId": 1,
        "name": "Shimla",
        "value": 753
    },
    {
        "IDistrictId": 9,
        "name": "Kullu",
        "value": 744
    },
    {
        "IDistrictId": 2,
        "name": "Solan",
        "value": 455
    },
    {
        "IDistrictId": 7,
        "name": "Hamirpur",
        "value": 357
    },
    {
        "IDistrictId": 6,
        "name": "Una",
        "value": 388
    },
    {
        "IDistrictId": 3,
        "name": "Sirmaur",
        "value": 314
    },
    {
        "IDistrictId": 8,
        "name": "Chamba",
        "value": 284
    },
    {
        "IDistrictId": 5,
        "name": "Bilaspur",
        "value": 231
    },
    {
        "IDistrictId": 12,
        "name": "Lahul and spiti",
        "value": 128
    },
    {
        "IDistrictId": 11,
        "name": "Kinnaur",
        "value": 97
    }
]
this.updateChartData(data)

    // this.adminService.GetDistrictSocietyDetail().subscribe((res: any) => {
 
      
    //   if (res?.status == 200 && res?.data) {
    //   if(res.data && res.data?.users){
    //     this.updateChartData(res.data.users)
    //   }else{
    //        this.updateChartData(res.data)
    //   }
    // }
    // }, (res) => {
    //   if (res.status != 200) {


    //   }
    // })
  }
  updateChartData(rows: any) {
    const categories: string[] = [];
    const receivedData: number[] = [];
    let totalReceived = 0
    rows.forEach((entry: any) => {


      categories.push(entry.name);


      receivedData.push(entry.value);
      totalReceived += entry.value
    });

    // this.ChartOptions = {
    //   title: "Himachal Pradesh in District's",
    //   subtitle: `Total Societies HP : ${totalReceived}`,
    //   categories,
    //   lagendEnable:false,
    //   seriesData: [{
    //     name: '',
    //     data: receivedData,
    //     type: 'bar'
    //   }]
    // };
    this.chartOptions = {
      credits: {
        enabled: false
      },
      chart: {
        map: HPMap as any
      },
      title: {
        text: "Himachal Pradesh in District's"
      },
      subtitle: {
        text: `Total Societies HP : ${totalReceived}`
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: 'bottom'
        }
      },
      colorAxis: {
        min: 0
      },
      series: [{
        type: 'map',
        name: 'Total Societies',
        data: rows,
        joinBy: ['NAME_2', 'name'],
        states: {
          hover: {
            color: '#BADA55'
          }
        },
        dataLabels: {
          enabled: true,
          // format: '{point.name}'
          format: '{point.properties.NAME_2}'
        }

      },
      ]
    };
    this.show = true;
  }

}
